(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casebang-stand-selector-backup"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-casebang-stand-selector]';

    const parseVariantJson = (id) => {
      const element = document.getElementById(id);
      if (!element) return [];
      try {
        return JSON.parse(element.textContent || '[]');
      } catch (_error) {
        return [];
      }
    };

    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;

      const form = document.getElementById(root.dataset.productFormId);
      if (!form) return;

      root.dataset.initialized = 'true';

      const productButtons = [...root.querySelectorAll('[data-stand-product]')];
      const modeButtons = [...root.querySelectorAll('[data-stand-mode]')];
      const summary = root.querySelector('[data-stand-summary]');
      const standPrice = root.querySelector('[data-stand-price]');
      const productInfo = root.closest('[id^="ProductInfo-"]') || document;
      const phoneSelector = productInfo.querySelector('#casebang-variants');
      const priceRoot = productInfo.querySelector('.casebang-next-buy-buttons-container .price');
      const phoneVariants = [
        ...parseVariantJson('product-variants-json'),
        ...parseVariantJson('accessory-variants-json'),
      ];
      const variantPrices = new Map(phoneVariants.map((variant) => [String(variant.id), variant]));
      const locale = window.Shopify?.locale || document.documentElement.lang || 'en-US';
      const currency = window.Shopify?.currency?.active || 'USD';
      const money = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: currency === 'THB' ? 0 : 2,
      });

      let selectedProduct = null;
      let selectedMode = 'cover';
      let activePreview = 'phone';
      let priceFrame = null;

      const previewHost = document.querySelector('#casebang-mockup-container');
      let preview = null;
      let previewImage = null;

      if (previewHost) {
        previewHost.classList.add('casebang-stand-preview-host');
        preview = document.createElement('div');
        preview.className = 'casebang-stand-preview';
        previewImage = document.createElement('img');
        previewImage.loading = 'eager';
        preview.appendChild(previewImage);
        previewHost.appendChild(preview);
      }

      let optionSheet = null;
      let optionSheetTitle = null;
      let optionSheetGrid = null;

      const ensureOptionSheet = () => {
        if (optionSheet) return;

        optionSheet = document.createElement('dialog');
        optionSheet.className = 'casebang-option-sheet';

        const panel = document.createElement('div');
        panel.className = 'casebang-option-sheet__panel';

        const header = document.createElement('div');
        header.className = 'casebang-option-sheet__header';

        optionSheetTitle = document.createElement('h3');
        optionSheetTitle.className = 'casebang-option-sheet__title';

        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'casebang-option-sheet__close';
        closeButton.setAttribute('aria-label', root.dataset.closeLabel || 'Close');
        closeButton.textContent = '×';
        closeButton.addEventListener('click', () => optionSheet.close());

        optionSheetGrid = document.createElement('div');
        optionSheetGrid.className = 'casebang-option-sheet__grid';

        header.append(optionSheetTitle, closeButton);
        panel.append(header, optionSheetGrid);
        optionSheet.append(panel);
        document.body.appendChild(optionSheet);

        optionSheet.addEventListener('click', (event) => {
          if (event.target === optionSheet) optionSheet.close();
        });
        optionSheet.addEventListener('close', () => document.body.classList.remove('casebang-sheet-open'));
      };

      const openOptionSheet = (group, heading) => {
        const options = group.querySelector('[class~="ca:flex-nowrap"][class~="ca:p-5"]');
        if (!options) return;
        const buttons = [...options.children].filter((element) => element.matches('button'));
        if (!buttons.length) return;

        ensureOptionSheet();
        optionSheetTitle.textContent = heading.textContent.trim();
        optionSheetGrid.replaceChildren();
        optionSheetGrid.className = 'casebang-option-sheet__grid';
        if (group.classList.contains('casebang-picker--cover')) optionSheetGrid.classList.add('casebang-picker--cover');
        if (group.classList.contains('casebang-picker--base')) optionSheetGrid.classList.add('casebang-picker--base');

        buttons.forEach((button) => {
          const clone = button.cloneNode(true);
          clone.classList.remove('casebang-mobile-featured', 'casebang-mobile-current');
          clone.classList.add('casebang-sheet-option');
          clone.removeAttribute('style');
          if (button.querySelector('[class~="ca:border-primary"]')) clone.classList.add('is-selected');
          clone.addEventListener('click', () => {
            button.click();
            optionSheet.close();
            requestAnimationFrame(decoratePhoneGroups);
          });
          optionSheetGrid.appendChild(clone);
        });

        document.body.classList.add('casebang-sheet-open');
        optionSheet.showModal();
      };

      const decoratePhoneGroups = () => {
        if (!phoneSelector) return;
        phoneSelector.querySelectorAll('[class~="ca:font-extrabold"]').forEach((heading) => {
          const group = heading.parentElement;
          if (!group) return;
          const title = heading.textContent.trim().toLowerCase();
          group.classList.add('casebang-picker-group');
          group.classList.toggle('casebang-picker--cover', title.includes('cover') && !title.includes('base'));
          group.classList.toggle('casebang-picker--base', title.includes('base'));

          const options = group.querySelector('[class~="ca:flex-nowrap"][class~="ca:p-5"]');
          if (!options) return;
          const buttons = [...options.children].filter((element) => element.matches('button'));
          buttons.forEach((button) => {
            if (button.querySelector(':scope > .price-item') || button.querySelector('img')) return;
            const priceSpacer = document.createElement('div');
            priceSpacer.className = 'ca:text-xs ca:leading-none ca:font-light ca:mt-1 price-item casebang-price-spacer';
            priceSpacer.setAttribute('aria-hidden', 'true');
            priceSpacer.innerHTML = '&nbsp;';
            button.appendChild(priceSpacer);
          });
          buttons.forEach((button) => button.classList.remove('casebang-mobile-featured', 'casebang-mobile-current'));

          const selected = buttons.find((button) => button.querySelector('[class~="ca:border-primary"]'));
          const featured = [selected, ...buttons.filter((button) => button !== selected)].filter(Boolean).slice(0, 4);
          featured.forEach((button) => button.classList.add('casebang-mobile-featured'));
          selected?.classList.add('casebang-mobile-current');

          let viewAll = group.querySelector('.casebang-view-all');
          if (buttons.length > 4) {
            if (!viewAll) {
              viewAll = document.createElement('button');
              viewAll.type = 'button';
              viewAll.className = 'casebang-view-all';
              viewAll.addEventListener('click', () => openOptionSheet(group, heading));
              group.appendChild(viewAll);
            }
            const viewAllText = `${root.dataset.viewAllLabel || 'View all'} ${buttons.length}`;
            if (viewAll.textContent !== viewAllText) viewAll.textContent = viewAllText;
          } else {
            viewAll?.remove();
          }
        });
      };

      decoratePhoneGroups();
      if (phoneSelector) {
        new MutationObserver(decoratePhoneGroups).observe(phoneSelector, {
          childList: true,
          subtree: true,
        });
      }

      const modeData = (mode = selectedMode) => {
        if (!selectedProduct) return null;
        const prefix = mode === 'cover' ? 'cover' : mode === 'base' ? 'base' : 'wallet';
        const id = selectedProduct.dataset[`${prefix}Id`];
        if (!id) return null;
        return {
          id,
          price: Number(selectedProduct.dataset[`${prefix}Price`] || 0),
          compareAtPrice: Number(selectedProduct.dataset[`${prefix}Compare`] || selectedProduct.dataset[`${prefix}Price`] || 0),
          available: selectedProduct.dataset[`${prefix}Available`] === 'true',
        };
      };

      const selectedPhoneIds = () => {
        const multiInputs = [...form.querySelectorAll('.casebang-multi-item-input')]
          .map((input) => input.value)
          .filter(Boolean);
        if (multiInputs.length) return [...new Set(multiInputs)];

        const primaryInput = form.querySelector('[name="id"], [data-primary-input="true"]');
        return primaryInput?.value ? [primaryInput.value] : [];
      };

      const updatePrice = () => {
        const phoneIds = selectedPhoneIds();
        if (!phoneIds.length || !priceRoot) return;

        let total = 0;
        let compareAtTotal = 0;

        phoneIds.forEach((id) => {
          const variant = variantPrices.get(String(id));
          if (!variant) return;
          total += Number(variant.price || 0);
          compareAtTotal += Number(variant.compare_at_price || variant.price || 0);
        });

        const standVariant = modeData();
        if (standVariant?.available) {
          total += standVariant.price;
          compareAtTotal += standVariant.compareAtPrice;
        }

        const formattedTotal = money.format(total / 100);
        const formattedCompareAt = money.format(compareAtTotal / 100);
        const saleItems = priceRoot.querySelectorAll('.price-item--sale');
        const regularItems = priceRoot.querySelectorAll('.price-item--regular');
        const allItems = priceRoot.querySelectorAll('.price-item');

        if (compareAtTotal > total && saleItems.length) {
          saleItems.forEach((item) => {
            item.textContent = formattedTotal;
          });
          regularItems.forEach((item) => {
            item.textContent = formattedCompareAt;
          });
          priceRoot.classList.add('price--on-sale');
        } else {
          allItems.forEach((item) => {
            item.textContent = formattedTotal;
          });
          priceRoot.classList.remove('price--on-sale');
        }
      };

      const schedulePriceUpdate = () => {
        if (priceFrame) cancelAnimationFrame(priceFrame);
        priceFrame = requestAnimationFrame(updatePrice);
      };

      const updateModeAvailability = () => {
        modeButtons.forEach((button) => {
          const variant = modeData(button.dataset.standMode);
          button.disabled = !selectedProduct || !variant?.available;
          const priceElement = button.querySelector('[data-mode-price]');
          if (priceElement) priceElement.textContent = variant ? money.format(variant.price / 100) : '';
        });

        if (selectedProduct && !modeData(selectedMode)?.available) {
          const fallback = modeButtons.find((button) => modeData(button.dataset.standMode)?.available);
          selectedMode = fallback?.dataset.standMode || 'cover';
        }
      };

      const showPhonePreview = () => {
        activePreview = 'phone';
        if (!preview || !previewImage) return;
        preview.classList.remove('is-active');
        preview.removeAttribute('data-preview-mode');
        previewImage.removeAttribute('src');
        previewImage.alt = '';
      };

      const render = () => {
        productButtons.forEach((button) => {
          const active = button === selectedProduct || (!selectedProduct && !button.dataset.standProduct);
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', String(active));
        });

        updateModeAvailability();

        modeButtons.forEach((button) => {
          const active = button.dataset.standMode === selectedMode;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', String(active));
        });

        const variant = modeData();
        if (selectedProduct && variant) {
          summary.textContent = selectedProduct.dataset.standLabel || '';
          standPrice.textContent = money.format(variant.price / 100);
          standPrice.hidden = false;
          if (preview && previewImage && activePreview === 'stand') {
            const previewSource = selectedProduct.dataset[`${selectedMode}Preview`] || '';
            previewImage.src = previewSource;
            previewImage.alt = selectedProduct.dataset.standLabel || '';
            preview.dataset.previewMode = selectedMode;
            preview.classList.toggle('is-active', Boolean(previewSource));
          }
        } else {
          summary.textContent = productButtons[0]?.querySelector('.casebang-stand__cover-name')?.textContent || '';
          standPrice.hidden = true;
          if (preview && previewImage) {
            preview.classList.remove('is-active');
            preview.removeAttribute('data-preview-mode');
            previewImage.removeAttribute('src');
            previewImage.alt = '';
          }
        }

        schedulePriceUpdate();
      };

      productButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!button.dataset.standProduct) {
            selectedProduct = null;
            selectedMode = 'cover';
            activePreview = 'phone';
          } else {
            const wasEmpty = !selectedProduct;
            selectedProduct = button;
            if (wasEmpty) selectedMode = 'cover';
            activePreview = 'stand';
          }
          render();
        });
      });

      modeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!selectedProduct || button.disabled) return;
          selectedMode = button.dataset.standMode;
          activePreview = 'stand';
          render();
        });
      });

      phoneSelector?.addEventListener('click', (event) => {
        if (!(event.target instanceof Element) || !event.target.closest('button')) return;
        showPhonePreview();
        requestAnimationFrame(decoratePhoneGroups);
      });

      form.addEventListener('change', schedulePriceUpdate, true);
      new MutationObserver(schedulePriceUpdate).observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['name', 'value', 'data-primary-input'],
      });

      form.addEventListener('formdata', (event) => {
        const standVariant = modeData();
        if (!standVariant?.available) return;

        const formData = event.formData;
        const ids = [];
        const itemIdKeys = [];

        for (const [key, value] of formData.entries()) {
          if (key === 'id' || /^items\[\d+\]\[id\]$/.test(key)) {
            if (value) ids.push(String(value));
            if (key !== 'id') itemIdKeys.push(key);
          }
        }

        formData.delete('id');
        itemIdKeys.forEach((key) => formData.delete(key));
        ids.push(standVariant.id);

        [...new Set(ids)].forEach((id, index) => {
          formData.append(`items[${index}][id]`, id);
        });
      });

      render();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cb-strap-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cb-strap-card')) {
  customElements.define('cb-strap-card', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-cbs-variants]').textContent);
      this.form = this.querySelector('form');
      this.querySelectorAll('[data-cbs-option]').forEach(control => control.addEventListener('change', () => this.updateVariant(), {signal:this.events.signal}));
      this.form.addEventListener('submit', event => this.addToCart(event), {signal:this.events.signal});
      this.querySelector('.cbs-card-options').hidden = false;
      this.setAttribute('data-ready', '');
      this.updateVariant();
    }
    disconnectedCallback() {this.events?.abort();this.events = null;}
    updateVariant() {
      const values = [...this.querySelectorAll('[data-cbs-option-group]')].map(group => {
        const control = group.querySelector('select, input:checked');
        const selected = group.querySelector('[data-cbs-selected-value]');
        if (selected) selected.textContent = control?.value || '';
        return control?.value;
      });
      const variant = this.variants.find(item => values.length === 0 || item.options.every((value,index) => value === values[index]));
      this.selectedVariant = variant;
      this.querySelector('[data-cbs-variant]').value = variant?.id || '';
      this.form.querySelector('[type=submit]').disabled = !variant?.available;
      this.querySelector('[data-cbs-submit-label]').textContent = variant ? (variant.available ? this.dataset.add : this.dataset.soldOut) : this.dataset.unavailable;
      this.querySelector('[data-cbs-price]').textContent = variant?.price || this.dataset.unavailable;
      if (variant) {
        this.querySelectorAll('[data-cbs-product-link]').forEach(link => link.setAttribute('href', variant.url));
        const image = this.querySelector('.cbq-card-image img');
        if (image && variant.image) {
          image.srcset = `${variant.small_image} 360w, ${variant.image} 720w`;
          image.src = variant.image;
          image.alt = variant.alt;
        }
      }
      const status = this.querySelector('.cbq-form-status');
      status.hidden = true;
      status.textContent = '';
    }
    async addToCart(event) {
      event.preventDefault();
      if (!this.selectedVariant?.available || this.pending) return;
      this.pending = true;
      const form = this.form;
      const body = new FormData(form);
      const controls = [...form.querySelectorAll('select,input,button')].map(control => ({control,disabled:control.disabled}));
      const button = form.querySelector('[type=submit]');
      const status = form.querySelector('.cbq-form-status');
      controls.forEach(({control}) => {control.disabled = true;});
      button.setAttribute('aria-busy','true');
      status.hidden = true;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart?.getSectionsToRender) {
        body.append('sections',cart.getSectionsToRender().map(section => section.id).join(','));
        body.append('sections_url',location.pathname);
        cart.setActiveElement?.(button);
      }
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js',{method:'POST',body,headers:{'X-Requested-With':'XMLHttpRequest'}});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        if (cart?.renderContents) {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } else {location.assign(root + 'cart');}
        status.textContent = this.dataset.added;
        status.hidden = false;
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
        status.hidden = false;
      } finally {
        controls.forEach(({control,disabled}) => {control.disabled = disabled;});
        button.disabled = !this.selectedVariant?.available;
        button.removeAttribute('aria-busy');
        this.pending = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
